import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km6};

  @media (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    gap: ${({ theme }) => theme.spacing.km8};
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.km2};
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km2};

  ${HeaderSection} {
    padding-left: ${({ theme }) => theme.spacing.km8};

    &:nth-child(1) {
      padding-left: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    flex-direction: row;
    flex-wrap: wrap;

    ${HeaderSection} {
      &:nth-child(2) {
        flex: 100% 1 0;
        order: 2;
        margin-top: ${({ theme }) => theme.spacing.km8};
      }

      &:nth-child(3) {
        padding-left: ${({ theme }) => theme.spacing.km4};
      }
    }
  }
`;
